import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import { UsersSelect } from "shared";
import { useEditTeamByIdMutation } from "entitites/teams/api/teamsApi";

export const EditTeamModal = ({
  open,
  handleClose,
  teamLead,
  name,
  teamId,
}: {
  open: boolean;
  handleClose: () => void;
  teamLead: string;
  name: string;
  teamId: string;
}) => {
  const [edit] = useEditTeamByIdMutation();
  const {
    register,
    handleSubmit,
    formState,
    setValue,
    setError,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: {
      name: name,
      teamLeadId: teamLead,
    },
  });
  const { errors } = formState;

  return (
    <Modal
      disableScrollLock={true}
      open={open}
      onClose={() => {
        reset();
        handleClose();
      }}
      aria-labelledby="employee-modal-title"
      aria-describedby="employee-modal-description"
    >
      <Box
        onSubmit={handleSubmit((data) => {
          if (!data.teamLeadId) {
            setError("teamLeadId", { message: "Укажите тимлида" });
          } else {
            edit({ teamId, data: data })
              .unwrap()
              .then(() => {
                reset();
                handleClose();
              })
              .catch((err) => console.log(err));
          }
        })}
        component="form"
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap={2.5}
        sx={{
          position: "absolute" as "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          width: 825,
          maxHeight: "90%",
          bgcolor: "background.paper",
          borderRadius: "4px",
          boxShadow: 24,
          p: 3.25,
          px: 10,
        }}
      >
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 0, right: 0 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          fontWeight={700}
          id="employee-modal-title"
          variant="h6"
          component="h2"
        >
          Редактировать команду {name}
        </Typography>
        <Box display="flex" alignItems="center" fontWeight={600} width="100%">
          Название команды
          <TextField
            inputProps={{
              ...register("name", {
                required: "Пожалуйста введите название",
              }),
              maxLength: 50,
            }}
            error={Boolean(errors.name)}
            helperText={errors.name?.message}
            label="Название"
            size="small"
            sx={{
              ml: "auto",
              width: 400,
            }}
          />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          fontWeight={600}
          width="100%"
        >
          ФИО Тимлидера
          <UsersSelect
            defaultValue={teamLead}
            error={Boolean(errors.teamLeadId)}
            helperText={errors.teamLeadId?.message}
            onChange={(data) => {
              clearErrors("teamLeadId");
              setValue("teamLeadId", data?.id);
            }}
          />
        </Box>

        <Box display="flex" gap={2}>
          <Button
            disableElevation
            onClick={() => {
              reset();
              handleClose();
            }}
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: "text.primary",
            }}
            variant="outlined"
          >
            Назад
          </Button>
          <Button
            type="submit"
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
            }}
            variant="contained"
          >
            Сохранить
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
